// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2vK_5","header":"PatientBlock_header__2L_kR","label":"PatientBlock_label__14z0C","option":"PatientBlock_option__3WuBp"};